const Mutations = Object.freeze({
	SET_ENTITIES: 'projectSettings/mergeConditions/SET_ENTITIES',
	SET_MERGE_CONDITIONS:
		'projectSettings/mergeConditions/SET_MERGE_CONDITIONS',
	SET_MERGE_CONDITION_FIELDS:
		'projectSettings/mergeConditions/SET_MERGE_CONDITION_FIELDS',
	SET_GRID_VIEW_FIELDS:
		'projectSettings/mergeConditions/SET_GRID_VIEW_FIELDS',
	DELETE_MERGE_CONDITION_FIELD:
		'projectSettings/mergeConditions/DELETE_MERGE_CONDITION_FIELD',
});

export const Actions = Object.freeze({
	CLEAR: 'projectSettings/mergeConditions/CLEAR',
	LOAD_ENTITIES: 'projectSettings/mergeConditions/LOAD_ENTITIES',
	LOAD_DEFAULT_GRIDVIEW:
		'projectSettings/mergeConditions/LOAD_DEFAULT_GRIDVIEW',
	LOAD_MERGE_CONDITIONS:
		'projectSettings/mergeConditions/LOAD_MERGE_CONDITIONS',
	INSERT_MERGE_CONDITION_FIELD:
		'projectSettings/mergeConditions/INSERT_MERGE_CONDITION_FIELD',
	DELETE_MERGE_CONDITION_FIELD:
		'projectSettings/mergeConditions/DELETE_MERGE_CONDITION_FIELD',
});

export const Getters = Object.freeze({
	ENTITIES: 'projectSettings/mergeConditions/ENTITIES',
	SELECTED_MERGE_CONDITION:
		'projectSettings/mergeConditions/SELECTED_MERGE_CONDITION',
	MERGE_CONDITIONS: 'projectSettings/mergeConditions/MERGE_CONDITIONS',
	MERGE_CONDITION_FIELDS:
		'projectSettings/mergeConditions/MERGE_CONDITION_FIELDS',
	AVAILABLE_FIELDS: 'projectSettings/mergeConditions/AVAILABLE_FIELDS',
});
import dataService from '../../../../../services/data/projectSettingsService';
import { GeneralActions } from '../../../../actions';
export default {
	state: {
		entities: [],
		selectedMergeCondition: null,
		gridViewFields: [],
		mergeConditions: [],
		mergeConditionFields: [],
	},
	mutations: {
		[Mutations.SET_ENTITIES](state, items) {
			state.entities = items;
		},
		[Mutations.SET_GRID_VIEW_FIELDS](state, items) {
			state.gridViewFields = items;
		},
		[Mutations.SET_MERGE_CONDITIONS](state, items) {
			state.mergeConditions = items;
		},
		[Mutations.SET_MERGE_CONDITION_FIELDS](state, items) {
			state.mergeConditionFields = items;
		},
		[Mutations.DELETE_MERGE_CONDITION_FIELD](state, item) {
			const index = state.mergeConditionFields.findIndex(
				(x) => x.Id == item.Id
			);
			if (index >= 0) {
				state.mergeConditionFields.splice(index, 1);
			}
		},
		[Mutations.SET_ENTITIES](state, items) {
			state.entities = items;
		},
	},
	actions: {
		[Actions.LOAD_MERGE_CONDITIONS]({ dispatch, commit }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getMergeCondition(id)
					.then((resp) => {
						commit(Mutations.SET_MERGE_CONDITIONS, resp.data);
						commit(
							Mutations.SET_MERGE_CONDITION_FIELDS,
							resp.data.MergeConditionFields
						);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => dispatch(GeneralActions.LOADING, false));
			});
		},
		[Actions.INSERT_MERGE_CONDITION_FIELD]({ dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.addMergeConditionField(item)
					.then(() => {
						dispatch(Actions.LOAD_MERGE_CONDITIONS, item.EntityId);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => dispatch(GeneralActions.LOADING, false));
			});
		},
		[Actions.DELETE_MERGE_CONDITION_FIELD]({ dispatch, commit }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.removeMergeConditionField(item.Id)
					.then(() => {
						commit(Mutations.DELETE_MERGE_CONDITION_FIELD, item);
					})
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.LOADING, false);
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},
		[Actions.LOAD_DEFAULT_GRIDVIEW]({ dispatch, commit }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getDefaultGridViewForEntity(id)
					.then((resp) => {
						commit(
							Mutations.SET_GRID_VIEW_FIELDS,
							resp.data.GridViewFields
						);
						dispatch(Actions.LOAD_MERGE_CONDITIONS, id);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => dispatch(GeneralActions.LOADING, false));
			});
		},
		[Actions.LOAD_ENTITIES]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getEntities()
					.then((resp) => {
						commit(Mutations.SET_ENTITIES, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => dispatch(GeneralActions.LOADING, false));
			});
		},
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_GRID_VIEW_FIELDS, []);
				commit(Mutations.SET_MERGE_CONDITIONS, []);
				commit(Mutations.SET_ENTITIES, []);
				commit(Mutations.SET_MERGE_CONDITION_FIELDS, []);
				resolve();
			});
		},
	},
	getters: {
		[Getters.ENTITIES]: (state) => {
			if (state.entities.length > 0) {
				return JSON.parse(JSON.stringify(state.entities));
			}
			return [];
		},
		[Getters.SELECTED_MERGE_CONDITION]: (state) => {
			return state.selectedMergeCondition;
		},
		[Getters.MERGE_CONDITIONS]: (state) => {
			if (state.mergeConditions && state.mergeConditions.length > 0) {
				return JSON.parse(JSON.stringify(state.mergeConditions));
			}
			return [];
		},
		[Getters.MERGE_CONDITION_FIELDS]: (state) => {
			if (
				state.mergeConditionFields &&
				state.mergeConditionFields.length > 0
			) {
				return JSON.parse(JSON.stringify(state.mergeConditionFields));
			}
			return [];
		},

		[Getters.AVAILABLE_FIELDS]: (state) => {
			if (!state.mergeConditionFields && state.gridViewFields.length <= 0)
				return [];
			if (
				(!state.mergeConditionFields &&
					state.gridViewFields.length > 0) ||
				(state.mergeConditionFields.length <= 0 &&
					state.gridViewFields.length > 0)
			)
				return JSON.parse(JSON.stringify(state.gridViewFields));
			let availableFields = [];
			if (
				state.mergeConditionFields &&
				state.mergeConditionFields.length > 0 &&
				state.gridViewFields.length > 0
			) {
				state.gridViewFields.forEach((gvf) => {
					let used = state.mergeConditionFields.find(
						(x) => x.GridViewFieldId == gvf.Id
					);
					if (!used) {
						availableFields.push(gvf);
					}
				});
				return availableFields;
			}
		},
	},
};
